module.exports = {"430522100":"酿溪镇","430522101":"严塘镇","430522102":"雀塘镇","430522103":"陈家坊镇","430522104":"潭溪镇","430522105":"寸石镇","430522106":"坪上镇","430522107":"龙溪铺镇","430522108":"巨口铺镇","430522109":"新田铺镇","430522110":"小塘镇","430522111":"太芝庙镇","430522112":"大新镇","430522200":"潭府乡","430522203":"迎光乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430522.json
// module id = 1691
// module chunks = 0